import { render, staticRenderFns } from "./ContentSubDetail.vue?vue&type=template&id=1287cba8&"
import script from "./ContentSubDetail.vue?vue&type=script&lang=js&"
export * from "./ContentSubDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentSubDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports